import { render, staticRenderFns } from "./QuestionListComponent.vue?vue&type=template&id=3c47df9b"
import script from "./QuestionListComponent.vue?vue&type=script&lang=js"
export * from "./QuestionListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports